<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="overlay"></div>
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-70 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">TRANSFORMAMOS IDEAS EN PROYECTOS REALES</h1>
            <h4>
              Proporcionamos servicios de calidad en proyectos de ingeniería en
              las áreas de obras civiles , acueducto, alcantarillado y energía.
            </h4>
            <br />
            <md-button to="/contactanos" class=" md-lg">CONTÁCTANOS</md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Conoce nuestro trabajo</h2>
              <h5 class="description">
                Cumplimos con la normatividad establecidad sustentándonos en
                tecnologías actualizadas y de bajo costo que nos permiten
                brindar la mayor calidad y eficiencia en el desarrollo de
                nuestros proyectos para brindar cumplimiento y garantía en las
                labores que se nos confían
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>waves</md-icon>
                  </div>
                  <h4 class="info-title">Acueductos y alcantarillados</h4>
                  <p>
                    Diseñamos, suministramos e instalamos todo lo necesario para
                    la realización de acueductos, alcantarillados y obras de
                    saneamiento básico.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-warning">
                    <md-icon>flash_on</md-icon>
                  </div>
                  <h4 class="info-title">Redes de energía</h4>
                  <p>
                    Diseñamos e instalamos el sistema de suministro eléctrico
                    para llevar energía desde la subestación de distribución
                    hasta los usuarios finales.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>report_problem</md-icon>
                  </div>
                  <h4 class="info-title">Solucionamos problemas</h4>
                  <p>
                    nos encontramos calificados para realizar reparaciones en
                    viaductos y alcantarillados para mantenerlos en el mejor
                    estado posible
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <md-button
              to="/servicios"
              class="md-primary md-wd"
              style="width:200px;"
              >Ver más</md-button
            >
          </div>
        </div>
      </div>

      <div class="section">
        <div class="container">
          <h2 class="title text-center">Algunos de nuestros proyectos</h2>
          <image-text
            nameOne="Planta de tratamiento"
            contentOne="Suministro e instalación de accesorior en acero carbón DN 1600mm, sobre tubería bocatoma a desarenador 2.
        Planta de tratamiento construida en puerto mallarino y el contratante fue el Consorcio embalse Puerto Mallarino
       "
            imageOne="foto-planta-tratamiento.jpg"
            dateOne="2015-2016"
            placeOne="Cali - Valle del Cauca"
            nameTwo="Tubería de bombeo"
            contentTwo="Suministro e instalación de
        200 metros de tubería en acero carbon DN 27 pulgadas, para Emcali en la ciudad de Yumbo.
      "
            imageTwo="instalacion-tuberias (1).jpg"
            dateTwo="2015"
            placeTwo="Yumbo - Valle del Cauca"
          ></image-text>

          <image-text
            nameOne="Red Contra Incendios"
            contentOne="Mantenimiento de la red contra incendios
          de la PTAR cañaveralejo EMCALI. proyecto realizado para Coningeniería S.A.S.

         "
            imageOne="dos.jpg"
            dateOne="2015"
            placeOne="Cali - Valle del Cauca"
            nameTwo="Puente Interconexión"
            contentTwo="Suministro e instalación de
          puente interconexión gatillos Facatativá. realizado para el Consorcio embalse Facatativá.
        "
            imageTwo="puente-facatativa.jpg"
            dateTwo="2014"
            placeTwo="Facatativá - Cundinamarca"
          ></image-text>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Déjanos asesorarte</h2>
              <h4 class="text-center description">
                Describe detalles sobre tu proyecto o necesidad, responderemos
                en un par de horas.
              </h4>
              <form class="contact-form" @submit.prevent="sendEmail">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Nombre</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Correo</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Ciudad</label>
                      <md-input v-model="ciudad" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Teléfono</label>
                      <md-input v-model="telefono" type="tel"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Mensaje</label>
                  <md-textarea v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button type="submit" class="md-success"
                      >Enviar mensaje</md-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicElements from "./components/BasicElementsSection";
import Navigation from "./components/NavigationSection";
import SmallNavigation from "./components/SmallNavigationSection";
import Tabs from "./components/TabsSection";
import NavPills from "./components/NavPillsSection";
import Notifications from "./components/NotificationsSection";
import TypographyImages from "./components/TypographyImagesSection";
import JavascriptComponents from "./components/JavascriptComponentsSection";
import ImageText from "./components/ImageText";
import { LoginCard } from "@/components";

export default {
  components: {
    ImageText
  },
  name: "index",
  bodyClass: "index-page",
  props: {
    logo: {
      type: String,
      default: require("@/assets/img/logo-blanco-lineas.png")
    },
    header: {
      type: String,
      default: require("@/assets/img/background-default.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      telefono: null,
      ciudad:null
    };
  },
  methods: {
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = true;
      }
    },
    sendEmail: function(e) {
      
      var data = this;
      var template_params = {
        reply_to: data.email,
        from_name: data.name,
        to_name: "Ingenieria y soluciones civiles",
        telefono: data.telefono,
        ciudad: data.ciudad,
        message_html: data.message
      };

      var service_id = "isc";
      var template_id = "template_f2p69cBy";
      emailjs.send(service_id, template_id, template_params).then(
        result => {
          data.name = null;
          data.email = null;
          data.message = null;
          alert("tu mensaje ha sido enviado");
        },
        error => {
          alert("No se pudo enviar tu mensaje, intenta de nuevo");
        }
      );
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`
      };
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
